import { FC } from "react";
import * as React from "react";
import Tippy, { TippyProps } from "@tippyjs/react";
import {
  Instance as TippyInstance,
  Props as TippyInstanceProps,
} from "tippy.js";

import "tippy.js/dist/tippy.css";
import "./tooltip.scss";

export interface InstanceProps extends TippyInstanceProps {
  hideOnEscapeKeyClick: boolean;
}
export interface TooltipInstanceProps extends TippyInstance {
  props: InstanceProps;
}

export interface TooltipProps extends TippyProps {
  title: string;
  children: React.ReactElement<any>;
}

const TooltipWrapper: FC<TooltipProps> = ({
  title,
  trigger = "mouseenter focusin",
  zIndex = 12,
  delay = [200, 10],
  placement = "bottom",
  hideOnClick = false,
  children,
  ...rest
}) => {
  const hideOnEscapeKeyClick = {
    name: "hideOnEscapeKeyClick",
    defaultValue: true,
    fn() {
      const hideTooltipInstance =
        ({ hide }: TooltipInstanceProps) =>
        (event: any) => {
          if (event.code === "Escape" || event.keyCode === 27) {
            hide();
          }
        };

      return {
        onShow(instance: TooltipInstanceProps) {
          document.addEventListener("keydown", hideTooltipInstance(instance));
        },
        onHide(instance: TooltipInstanceProps) {
          document.removeEventListener(
            "keydown",
            hideTooltipInstance(instance),
          );
        },
      };
    },
  };

  return (
    <Tippy
      content={title}
      trigger={trigger}
      zIndex={zIndex}
      delay={delay}
      placement={placement}
      hideOnClick={hideOnClick}
      plugins={[hideOnEscapeKeyClick]}
      interactive
      {...rest}
    >
      {children}
    </Tippy>
  );
};

export default TooltipWrapper;
